<template>
  <v-container fluid>
    <div class="divbody">
      <v-row align="center" justify="center" class="sign-row">
        <v-col
          align="center"
          justify="center"
          xs="12"
          sm="12"
          md="7"
          lg="7"
          xl="7"
        >
          <CImage
            :url="'small_house.svg'"
            :square="false"
            :alt="'image not found'"
          />
        </v-col>
        <v-col
          align="center"
          justify="center"
          xs="12"
          sm="12"
          md="5"
          lg="5"
          xl="5"
        >
          <v-card class="login-card">
            <v-card-title class="con-title text-no-wrap">
              Inscription
            </v-card-title>

            <div class="fields">
              <v-form ref="form" v-model="valid">
                <v-select
                  v-model="form.civility"
                  label="Civilité"
                  :items="['Mr', 'Mme', 'Autre']"
                  outlined
                  required
                  dense
                ></v-select>
                <v-text-field
                  v-model="form.name"
                  label="Nom"
                  outlined
                  :rules="rules.nameRules"
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="form.firstname"
                  label="Prénom"
                  outlined
                  :rules="rules.nameRules"
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="form.structure"
                  label="Structure (optionnel)"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="form.fonction"
                  label="Fonction (optionnel)"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="form.phone"
                  label="Téléphone (optionnel)"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="form.email"
                  :rules="rules.emailRules"
                  required
                  label="Email"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="form.password"
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  label="mot de passe"
                  @click:append="show1 = !show1"
                  :rules="rules.passRule"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-form>
            </div>
            <p class="already_have_account blue_10--text">
              <a @click="redirect('Connection')"
                >Vous avez déjà un compte ? <b>Connectez-vous !</b></a
              >
            </p>
            <p class="conditions">
              En cliquant sur le bouton “Je m’inscris”, vous acceptez
              <span class="conditions-bold">
                les conditions générales d’utilisation
              </span>
              de foncierpublic.com
            </p>
            <br />
            <v-btn
              :disabled="!valid"
              outlined
              class="signin text-none"
              @click="signUp"
            >
              Je m'inscris
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-bottom-sheet v-model="sheet.display">
      <v-sheet class="text-center" height="200px">
        <v-btn
          class="mt-6"
          text
          color="red"
          @click="sheet.display = !sheet.display"
          >Continuer</v-btn
        >
        <div class="py-3">{{ sheet.text }}</div>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<style scoped>
.divbody {
  padding: 5%;
}

.sign-row {
  padding: 20px;
}

.fields * {
  padding-top: 0% !important;
  padding-bottom: 0% !important;
  /* margin: 0% 0% !important; */
}

.sign-up-span:hover {
  color: "secondary";
  cursor: pointer;
}

.login-card {
  background-color: white !important;
  padding: 50px;
  border-radius: 50px;
}

.signup {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}

.conditions {
  font-family: Poppins;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 22px;
  padding-bottom: 0 !important;
}

.already_have_account {
  font-weight: 300;
  font-size: 14px;
  line-height: 22px;
}

.conditions-bold {
  padding: 0;
  font-weight: 500;
  cursor: pointer;
}

.signin {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  background-color: #e0e8f9;
  border-color: #98aeeb;
  color: #19216c;
  text-decoration: none;
}

.con-title {
  display: block;
  text-align: center;
  /* Semibold / 56 px | 64 px */
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 45px;
  line-height: 64px;

  padding-bottom: 50px;

  /* identical to box height, or 114% */
  color: #262626;
}

.svg-box {
  max-width: 60% !important;
}
</style>

<script>
import CImage from "../components/HomeSections/SubComponents/Image";
import { inscription } from "@/services/user";

export default {
  components: { CImage },
  data() {
    return {
      valid: true,
      show1: false,
      form: {
        name: "",
        firstname: "",
        email: "",
        password: "",
        phone: "",
        civility: null,
        structure: "",
        fonction: ""
      },
      rules: {
        emailRules: [
          v => !!v || "l'E-mail est requis.",
          v => /.+@.+\..+/.test(v) || "l'E-mail doit être valide."
        ],
        nameRules: [
          v => !!v || "Le champ est requis.",
          v =>
            (v && v.length <= 20) ||
            "La saisie ne doit pas dépasser les 20 caractères."
        ],
        passRule: [
          v => !!v || "Le champ est requis",
          v =>
            (v && v.length >= 6) ||
            "Le mot de passe doit faire au moins 6 caractères."
        ]
      },
      sheet: {
        display: false,
        text: ""
      }
    };
  },
  methods: {
    signUp() {
      let that = this;
      inscription(this.form)
        .then(() => {
          that.sheet.display = true;
          that.sheet.text =
            "Bienvenue chez foncierpublic.com " + that.form.firstname;

          that.form = {
            name: "",
            firstname: "",
            email: "",
            password: "",
            phone: "",
            civility: null,
            structure: "",
            fonction: ""
          };
          this.$refs.form.reset();
          this.redirect("Home");
        })
        .catch(error => {
          var errorCode = error.code;
          var errorMessage = error.message;
          // ...
          that.sheet.display = true;
          that.sheet.text = errorCode + ": " + errorMessage;
        });
    }
  }
};
</script>
